import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import Select from 'react-select';
import Titulo from '../comum/Titulo';
import buscarItinerarios from '../../actions/itinerario/buscarItinerarios';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos'
import excluirItinerarios from '../../actions/itinerario/exclurItinerario';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getOperadorEmpresa,
    getGestorOperacoes,
    getPerfisVendedores,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarRotas from '../../actions/rota/buscarRotas';
import determinaPaginaAtual from '../../actions/itinerario/determinarPaginaAtualItinerario'
import limparItinerarios from '../../actions/itinerario/limparItinerarios'
import selecionarRota from '../../actions/rota/selecionarRota';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import buscarUsuariosMotorista from '../../actions/usuario/buscarUsuariosMotorista';
import {showSuccessMsg} from '../../util/messagesUtil';
import Itinerarios from './Itinerarios';
import OperacoeItinerarioEmLote from './OperacoeItinerarioEmLote';
import buscarPrestadoresSimples from '../../actions/prestador/buscarPrestadoresSimples';
import PainelFiltragem from '../itinerario/PainelFiltrosItinerario';
import buscarTrechos from '../../actions/trecho/buscarTrechos';
import { buscarUsuariosVendedores } from '../../actions/usuario/buscarUsuarios';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Data/Hora saída</div>
            <div className="col">Assentos</div>
            <div className="col">Veículo</div>
            <div className="col">Rota</div>
            <div className="col">Prestador</div>
            <div className="col">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarItinerarios extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.state = {
            itinerarioSelecionado: null,
            textoFiltro: null,
            rotaSelecionada: null,
            motoristasSelecionados: [],
            trechosSelecionados: []
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinaPaginaAtual(1)
    }

    componentDidMount() {
        this.props.buscarTiposPreco();
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarUsuariosMotorista(this.props.empresaSelecionada.id);
            this.props.buscarPrestadoresSimples(this.props.empresaSelecionada.id);
            this.props.buscarRotas(this.props.empresaSelecionada.id, null, null, null, true);
            this.props.buscarVeiculos(this.props.empresaSelecionada.id,null, null, null, false);
            this.props.buscarUsuariosVendedores(this.props.empresaSelecionada.id);
            if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
                this.props.buscarItinerarios(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparItinerarios();
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.props.buscarRotas(this.props.empresaSelecionada.id);
                this.props.buscarVeiculos(this.props.empresaSelecionada.id,null, null, null, false);
                this.props.buscarUsuariosMotorista(this.props.empresaSelecionada.id);
            }
            this.props.selecionarRota([]);
        }
        if (alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerarios(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
        }
    }


    buscarItinerarios() {
        this.props.buscarItinerarios(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    excluir() {
        this.props.excluirItinerarios(this.props.itinerarioSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Itinerário excluido com sucesso.');

                this.buscarItinerarios();
                this.props.selecionarItinerario(null);
            })
    }


    limparCampos() {
        this.props.changeFieldValue('formularioCadastroItinerario',
            'itinerarioId', '');
        this.props.changeFieldValue('formularioCadastroItinerario',
            'veiculo', '');
        this.props.changeFieldValue('formularioCadastroItinerario',
            'rota', '');
        this.props.changeFieldValue('formularioCadastroItinerario',
            'assentosDisponiveis', '');
        this.props.selecionarItinerario(null);
        this.props.limparItinerarios()
    }


    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoItinerario() {
        if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getGestorOperacoes(this.props.empresaSelecionada.id),
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                    <div className="row col-md-12 justify-content-around">
                        <div className="row col-md-4">
                            <button data-toggle="modal" data-target="#modalCadastrarItinerario"
                                    className="btn btn-laranja">
                                Criar Itinerário
                            </button>
                        </div>
                        <div className="row col-md-4">
                            <button data-toggle="modal" data-target="#modalCadastrarItinerarioPorPeriodo"
                                    className="btn btn-laranja ml-2">
                                Criar Itinerários por período
                            </button>
                        </div>
                        <div className="row col-md-4 justify-content-end">
                            <OperacoeItinerarioEmLote habilitadoSite={this.props.empresaSelecionada.habilitadoSite}/>
                        </div>
                    </div>
                </Autorizacao>)
        }
        return ''
    }

    selecionarRota(rota) {
        this.props.selecionarRota(rota);
        this.props.buscarItinerarios(this.props.empresaSelecionada.id, rota.value, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
        this.props.buscarTrechos(this.props.empresaSelecionada.id, rota.value);
    }

    exibirComboRotas(event) {
        if (this.props.rotas) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione uma rota...'
                        options={this.props.rotas.map(elemento => (
                            {
                                label: elemento.descricao,
                                value: elemento.id,
                              cidadeOrigem: elemento.cidadeOrigem,
                              cidadeDestino: elemento.cidadeDestino,
                              prefixo: elemento.prefixo
                            }))}
                        onChange={value => this.selecionarRota(value)}
                        value={this.props.rotaSelecionada}
                    />
                    {event.meta.touched
                    && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }
        return '';
    }

    exibirCamposBusca() {
        return <div className="col-12 col-sm-12 col-md-12 mt-2 mb-4">
            <div className='row'>
                <div className='col-10 col-sm-10 col-md-8'>
                    <label>Rota/Prestador</label>
                    <Field name='rota' component={this.exibirComboRotas.bind(this)}/>
                </div>
            </div>
        </div>
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-md-12">
                    <div className='col-md-12'>
                        <Titulo texto="Gerenciar Itinerários" urlRetorno="/menu-itinerario"/>
                    </div>
                    <div className='container-padrao'>
                        <div className='row mb-2'>
                            <div className='col-md-6'>
                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                    <CampoSelecionarEmpresa/>
                                </Autorizacao>
                            </div>
                        </div>
                        <div className='row'>
                            {this.props.rotaSelecionada && this.props.rotaSelecionada.value ? <div className="col-12 filtro-busca">
                                <PainelFiltragem/>
                            </div> : ''}
                            {this.exibirCamposBusca()}
                            {this.exibirBotaoNovoItinerario()}
                            <div className='col-12 mt-4 mb-0 row d-flex justify-content-center'>
                                <h4> {this.props.rotaSelecionada && this.props.rotaSelecionada.value ? `${this.props.rotaSelecionada.value}: ${this.props.rotaSelecionada.label}` : ''} </h4>
                            </div>
                        </div>
                        <Itinerarios isEdicao={true} buscarItinerarios={this.buscarItinerarios.bind(this)} />
                    </div>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        itinerarios: state.itinerarios.itinerarios,
        veiculos: state.veiculos.veiculos,
        rotas: state.rotas.rotas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        itinerarioSelecionado: state.itinerarioSelecionado,
        rotaSelecionada: state.rotaSelecionada,
        filtrosAdicionados: state.filtrosAdicionadosItinerario,
    });


export default connect(mapStateToProps,
    {
        buscarItinerarios,
        excluirItinerarios,
        buscarRotas,
        buscarVeiculos,
        determinaPaginaAtual,
        selecionarRota,
        limparItinerarios,
        buscarTiposPreco,
        selecionarItinerario,
        buscarUsuariosMotorista,
        buscarPrestadoresSimples,
        buscarTrechos,
        buscarUsuariosVendedores
    })(reduxForm({
    form: 'formularioCadastroItinerario'
})(PainelGerenciarItinerarios))